export const API_URL = import.meta.env.VITE_API_URL
export const LOGIN_SYSTEM_URL = import.meta.env.VITE_CLOUD_LOGIN_SYSTEM
